import { zodTransformFirestoreTimestampToDate } from "../utils/zodUtils.mjs";
import { zodFlavorId } from "./ids.mjs";
import { defineFirestoreCollection } from "./firebaseCollectionSchema.mjs";
import { PiiCategory, meta } from "./meta.mjs";
import { CLASS_REMINDER_GLOBALS_FIELD, DEFAULT_CLASS_REMINDER_GLOBALS, classReminderGlobalsSchema } from "./classReminderGlobals.mjs";
import { customerIoChannelOptOutFieldSchema } from "./customerIoChannelOptOut.mjs";
import z from "zod";

// src/models/customerNotificationConfiguration.ts
/** Coerce missing / invalid `tokens` to `{}` so reads stay valid while `tokens` is required on the model. */
const notifConfigDeviceTokenMapSchema = z.preprocess((v) => v !== null && v !== void 0 && typeof v === "object" && !Array.isArray(v) ? v : {}, meta(z.record(z.string(), z.unknown()), { pii: { category: "credential" } }));
/** Default body for a new `customer_notification_configuration/{customerId}` document. */
const DEFAULT_CUSTOMER_NOTIFICATION_CONFIGURATION_DOC = {
	tokens: {},
	[CLASS_REMINDER_GLOBALS_FIELD]: { ...DEFAULT_CLASS_REMINDER_GLOBALS },
	eligibleForNotifications: false,
	configVisibleOnUI: false
};
const customerNotificationConfigurationDocumentSchema = z.object({
	id: zodFlavorId(),
	tokens: notifConfigDeviceTokenMapSchema,
	[CLASS_REMINDER_GLOBALS_FIELD]: classReminderGlobalsSchema.optional(),
	eligibleForNotifications: z.boolean().optional(),
	/** `yyyy-MM-dd` digest anchor (America/New_York) after daily class-summary SMS sent. */
	lastDailyClassSummarySmsNyDate: z.string().optional(),
	/** When true, customer may see per-schedule notification controls (additive to dev/local gates). */
	configVisibleOnUI: z.boolean().optional(),
	/** Customer.io email/SMS opt-out state (record-only; does not change classReminderGlobals). */
	customerIoChannelOptOut: customerIoChannelOptOutFieldSchema,
	/** Set after first welcome SMS (`class_reminder_sms`) on valid mobilePhone. */
	welcomeSmsSentAt: z.any().transform(zodTransformFirestoreTimestampToDate).optional()
}).passthrough();
/** True only when `configVisibleOnUI` is explicitly `true`. */
function effectiveConfigVisibleOnUI(doc) {
	return doc?.configVisibleOnUI === true;
}
const CustomerNotificationConfiguration = defineFirestoreCollection("customer_notification_configuration", customerNotificationConfigurationDocumentSchema, void 0, { dwReplication: false });

export { CustomerNotificationConfiguration, DEFAULT_CUSTOMER_NOTIFICATION_CONFIGURATION_DOC, customerNotificationConfigurationDocumentSchema, effectiveConfigVisibleOnUI };
//# sourceMappingURL=customerNotificationConfiguration.mjs.map